import { toQueryString } from 'utils/utils';
import fetchJsonp from 'utils/jsonp';

export const submitMailchimpSignUpForm = ({ data, successAction, errorAction, extraFormSubmitAction, widget }) => {
	data.u = 'a832f48f937a864af2e7f539c';
	data.id = '3cca162333';
	const apiURL = 'https://powster.us2.list-manage.com/subscribe/post-json' + toQueryString(data);

	if (window.grecaptcha && window.grecaptcha.getResponse(window[widget]).length === 0) {
		return errorAction('captcha');
	}

	return fetchJsonp(apiURL, { callbackArg: 'c' }).then(response => {
		if (response.result === 'error') {
			errorAction(response.msg);
		} else if (response.result === 'success') {
			successAction();
		}
		if (typeof extraFormSubmitAction === 'function') {
			extraFormSubmitAction();
		}
	});
};
